import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { ChatAppMessageSwitchAgent } from "../chat-app.model";

@Component({
  selector: "message-switch-agent",
  templateUrl: "./message-switch-agent.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageSwitchAgentComponent {
  @Input() message!: ChatAppMessageSwitchAgent;
}
